"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("evolution-common/lib/services/questionnaire/types");
const sectionConfigs_1 = __importDefault(require("./sections/home/sectionConfigs"));
const sectionConfigs_2 = __importDefault(require("./sections/household/sectionConfigs"));
const sectionConfigs_3 = __importDefault(require("./sections/personsTrips/sectionConfigs"));
const sectionConfigs_4 = __importDefault(require("./sections/selectPerson/sectionConfigs"));
const sectionConfigs_5 = __importDefault(require("./sections/tripsIntro/sectionConfigs"));
const sectionConfigs_6 = __importDefault(require("./sections/visitedPlaces/sectionConfigs"));
const sectionConfigs_7 = __importDefault(require("./sections/segments/sectionConfigs"));
const sectionConfigs_8 = __importDefault(require("./sections/travelBehavior/sectionConfigs"));
const sectionConfigs_9 = __importDefault(require("./sections/longDistance/sectionConfigs"));
const sectionConfigs_10 = __importDefault(require("./sections/end/sectionConfigs"));
const sectionConfigs_11 = __importDefault(require("./sections/completed/sectionConfigs"));
// Export all the sections configs
const sectionsConfigs = {
    home: sectionConfigs_1.default,
    household: sectionConfigs_2.default,
    personsTrips: sectionConfigs_3.default,
    selectPerson: sectionConfigs_4.default,
    tripsIntro: sectionConfigs_5.default,
    visitedPlaces: sectionConfigs_6.default,
    segments: sectionConfigs_7.default,
    travelBehavior: sectionConfigs_8.default,
    longDistance: sectionConfigs_9.default,
    end: sectionConfigs_10.default,
    completed: sectionConfigs_11.default
};
exports.default = (0, types_1.getAndValidateSurveySections)(sectionsConfigs);
